<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2233_44759)">
<mask id="path-1-inside-1_2233_44759" fill="white">
<rect x="3" y="3" width="16" height="16" rx="1.2"/>
</mask>
<rect x="3" y="3" width="16" height="16" rx="1.2" stroke="currentColor" stroke-width="3.4" mask="url(#path-1-inside-1_2233_44759)"/>
</g>
<defs>
<clipPath id="clip0_2233_44759">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
